import { BarChart3, Building2, FileWarning, KeyRound, Link2, UserRound } from 'lucide-react';

/** Ícone e rótulo de cada tipo de ponto da revisão de artigo público. */
export const FINDING_TYPES = {
  CLIENT_NAMES: { icon: Building2, label: 'Cliente citado' },
  INTERNAL_HOSTS: { icon: Link2, label: 'URL interna' },
  CREDENTIALS: { icon: KeyRound, label: 'Possível credencial' },
  PERSONAL_DATA: { icon: UserRound, label: 'Dado pessoal' },
  INTERNAL_NUMBERS: { icon: BarChart3, label: 'Número interno' },
  FORBIDDEN_TERM: { icon: FileWarning, label: 'Termo proibido' },
};

export const findingMeta = (f) => FINDING_TYPES[f.type] || { icon: FileWarning, label: f.typeLabel || 'Ponto' };

export const severityLabel = (s) => (s === 'GRAVE' ? 'Grave' : 'Atenção');

/** O que a revisão procura (painel de publicação, 3a). */
export const REVIEW_LOOKS_FOR = [
  { icon: Building2, label: 'Nomes de clientes e parceiros' },
  { icon: Link2, label: 'URLs, IPs e hosts internos' },
  { icon: KeyRound, label: 'Senhas, tokens e chaves' },
  { icon: UserRound, label: 'E-mails, CPF e nomes de pessoas' },
  { icon: BarChart3, label: 'Números internos (preços, contratos, métricas)' },
];
